export const getEnv = () => {
  var hostname = window.location.hostname;

  switch (hostname) {
    case 'shopeepay.com':
      return 'production'

    //   case 'live-test.shopeepay.com':
    //     return 'livetest';
    //     break;

    //   case 'uat.shopeepay.com':
    //     return 'uat';
    //     break;

    case 'test.shopeepay.com':
      return 'test'

    default:
      return 'local'

  }
};
